import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ClientClassesPipe'
})
export class ClientClassesPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    value = value ? value.replace(/[{}]/g,'').split(',').join(', ') : 'N/A'
    return value;
  }

}
